<template>
  <div style="margin-top: 16px;">
    <el-radio
        v-for="(item, index) in list.children || list.taxDialogOptionList"
        v-model="list.checked"
        :label="item.optionCode"
        :key="index"
        v-if="item.optionType!=1"
    >
    <span>
        {{ item.optionName }}
    </span>
    </el-radio>
    <div v-else style="display: flex;align-items: center;margin-top:10px;">
      <div>{{ item.optionName }}</div>
      <el-input style="width:300px;" type="textarea" :rows="2" v-model="item.memoJson">
      </el-input>
    </div>
    <template v-for="(item, index) in list.children || list.taxDialogOptionList">
      <diguizj
          :key="index"
          :list="item"
          v-if="item.children && item.children.length > 0 && list.checked==item.optionCode"
      ></diguizj>
    </template>
  </div>
</template>
<script>
export default {
  name: 'diguizj',
  props: {
    list: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  methods: {
    changes() {
    }
  }
};
</script>
<style scoped>
@import url('./index.less');
</style>